module.exports = __webpack_public_path__ + "img/icon-energy.6218eb17.svg";